import Vue from 'vue'
import Router from 'vue-router'
import Layout from '../layout/layout'
import Login from '../login/index'
import mainIndex from '../index/mainIndex.vue'
import en from '../../../i18n/lang/en'

// ==================== 懒加载组件定义 ====================

// 基础页面
const NotFound = () => import('../page404')
const Forget = () => import('../forget/index.vue')
const Register = () => import('../register/index.vue')
const RegisterByExpert = () => import('../register/expert.vue')
const RegisterNew = () => import('../register/new.vue')
const personal = () => import('../personal/index.vue')
const Message = () => import('../message/index.vue')
const DownLoadCenter = () => import('../downloadCenter/index.vue')

// 会员管理
const memberManagement = () => import('../memberManagement/memberManagement.vue')

// 专家管理
const expertManagement = () => import('../expertManagement/expertManagement.vue')

// 会员服务
const memberServicePages = {
  excellenceScore: () => import('../memberServices/excellenceScore.vue'),
  membershipDues: () => import('../memberServices/membershipDues.vue'),
  paymentManagement: () => import('../memberServices/paymentManagement.vue'),
  realNameEmployManage: () => import('../memberServices/realNameEmployManage.vue'),
  eventManagement: () => import('../memberServices/eventManagement.vue')
}

// 配置管理
const configPages = {
  Integral: () => import('../configuration/integral.vue'),
  Speciality: () => import('../configuration/speciality.vue'),
  memberNature: () => import('../configuration/memberNature.vue'),
  Review: () => import('../configuration/review.vue'),
  ExcellenceScoreCfg: () => import('../configuration/excellenceScoreCfg.vue'),
  ProjectNumber: () => import('../configuration/ProjectNumber.vue')
}

// 用户/角色/菜单管理
const User = () => import('../User/user.vue')
const Menu = () => import('../menu/index.vue')
const Role = () => import('../role/index.vue')

// 评审管理
const ExamineList = () => import('../examine/index.vue')
const ExamineDefine = () => import('../examine/define.vue')

// 会员/专家申请
const memberApplication = () => import('../member/memberApplication.vue')
const paymentDeclaration = () => import('../member/paymentDeclaration.vue')
const expertApplication = () => import('../expert/expertApplication.vue')
const examineProject = () => import('../expert/examineProject.vue')

// 日志与模板
const log = () => import('../log/loglist.vue')
const Template = () => import('../Template/Template.vue')
const Auditing = () => import('../projectApplication/Auditing.vue')

// 首页
const memberIndex = () => import('../index/memberIndex.vue')
const expert = () => import('../expert/index.vue')

Vue.use(Router)

// 修复 NavigationDuplicated 错误
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

// ==================== 路由元数据配置 ====================

/**
 * 项目类型配置 - 统一管理所有项目路由
 * 如需新增项目类型，只需在此添加配置即可
 */
const PROJECT_TYPES = [
  { key: 'szlsppjdj',nameKey: 'szlsppjdj',adminComp: '../projectManagement/szlsppjdj.vue',memberComp: '../projectApplication/szlsppjdj.vue'}, 
  { key: 'syzj', nameKey: 'syzj', adminComp: '../projectManagement/syzj.vue', memberComp: '../projectApplication/syzj.vue' },
  { key: 'ssfgd', nameKey: 'ssfgd', adminComp: '../projectManagement/ssfgd.vue', memberComp: '../projectApplication/ssfgd.vue' },
  { key: 'gdsyzj', nameKey: 'gdsyzj', adminComp: '../projectManagement/gdsyzj.vue', memberComp: '../projectApplication/gdsyzj.vue' },
  { key: 'gdsyzjgj', nameKey: 'gdsyzjgj', adminComp: '../projectManagement/gdsyzjgj.vue', memberComp: '../projectApplication/gdsyzjgj.vue' },
  { key: 'gdsyzzsj', nameKey: 'gdsyzzsj', adminComp: '../projectManagement/gdsyzzsj.vue', memberComp: '../projectApplication/gdsyzzsj.vue' },
  { key: 'gdslssgj', nameKey: 'gdslssgj', adminComp: '../projectManagement/gdslssgj.vue', memberComp: '../projectApplication/gdslssgj.vue' },
  { key: 'gdsszsfj', nameKey: 'gdsszsfj', adminComp: '../projectManagement/gdsszsfj.vue', memberComp: '../projectApplication/gdsszsfj.vue' },
  { key: 'gdsszyzj', nameKey: 'gdsszyzj', adminComp: '../projectManagement/gdsszyzj.vue', memberComp: '../projectApplication/gdsszyzj.vue' },
  { key: 'gmxmsb', nameKey: 'gmxmsb', adminComp: '../projectManagement/gmxmsb.vue', memberComp: '../projectApplication/gmxmsb.vue' },
  { key: 'sgwfgd', nameKey: 'sgwfgd', adminComp: '../projectManagement/sgwfgd.vue', memberComp: '../projectApplication/sgwfgd.vue' },
]

// 会员服务子路由配置
const MEMBER_SERVICE_ROUTES = [
  { path: '/membershipDues', name: 'membershipDues', component: memberServicePages.membershipDues },
  { path: '/paymentManagement', name: 'paymentManagement', component: memberServicePages.paymentManagement },
  { path: '/realNameEmployManage', name: 'realNameEmployManage', component: memberServicePages.realNameEmployManage },
  { path: '/excellenceScore', name: 'excellenceScore', component: memberServicePages.excellenceScore },
  { path: '/eventManagement', name: 'eventManagement', component: memberServicePages.eventManagement }
]

// 配置管理子路由
const CONFIG_ROUTES = [
  { path: '/configuration/integral', name: 'integral', component: configPages.Integral },
  { path: '/configuration/speciality', name: 'speciality', component: configPages.Speciality },
  { path: '/configuration/memberNature', name: 'memberNature', component: configPages.memberNature },
  { path: '/configuration/review', name: 'review', component: configPages.Review },
  { path: '/configuration/excellenceScoreCfg', name: 'excellenceScoreCfg', component: configPages.ExcellenceScoreCfg },
  { path: '/configuration/ProjectNumber', name: 'ProjectNumber', component: configPages.ProjectNumber }
]

// ==================== 路由构建工具函数 ====================

const routeName = en.routeName

/**
 * 创建基础路由对象
 */
const createRoute = (options) => ({
  iconCls: 'fa fa-dashboard',
  hidden: false,
  children: [],
  ...options
})

/**
 * 创建 Layout 包裹的路由
 */
const createLayoutRoute = (path, name, children, options = {}) => createRoute({
  path,
  name,
  component: Layout,
  children: Array.isArray(children) ? children : [children],
  ...options
})

/**
 * 创建单独页面路由（alone: true）
 */
const createAloneRoute = (path, name, component, options = {}) => createLayoutRoute(path, name, {
  path,
  name: name.toLowerCase(),
  component,
  iconCls: 'fa fa-dashboard'
}, { alone: true, ...options })

/**
 * 动态生成项目管理路由
 */
const generateProjectRoutes = (isAdmin) => {
  return PROJECT_TYPES.map(type => {
    const compPath = isAdmin ? type.adminComp : type.memberComp
    // 使用动态 import，注意：需要确保路径正确
    const component = () => import(/* webpackChunkName: "[request]" */ `../${isAdmin ? 'projectManagement' : 'projectApplication'}/${type.key}.vue`)
    
    return {
      path: `/${type.key}`,
      iconCls: 'fa el-icon-s-flag',
      name: routeName[isAdmin ? type.nameKey : `${type.nameKey}_member`],
      component,
      hidden: false,
      children: []
    }
  })
}

// ==================== 默认路由（无需权限）====================

const defaultRouter = [
  { id: '101', path: '/login', component: Login, hidden: true },
  { id: '102', path: '/register', component: RegisterNew, hidden: true },
  { id: '105', path: '/forget', component: Forget, hidden: true },
  { id: '103', path: '/register/expert', component: RegisterByExpert, hidden: true },
  { path: '/404', component: NotFound, name: '404', hidden: true }
]

// ==================== 权限路由生成 ====================

/**
 * 根据用户类型生成路由
 * @param {number} userType - 用户类型
 * @returns {Array} 路由配置数组
 */
export const generateRoutesByRole = (userType) => {
  const routes = []
  
  // 用户类型常量定义
  const USER_TYPE = {
    NORMAL: '0',
    ADMIN: '1',
    MEMBER: '2',
    EXPERT: '3',
    ASSOCIATION: '4',
    EXPERT_EXTRA: '5'
  }

  // 管理员 & 协会管理
  if (userType == USER_TYPE.ADMIN || userType == USER_TYPE.ASSOCIATION) {
    // 首页
    routes.push(createLayoutRoute('/index', routeName.home, {
      path: '/index',
      name: 'home',
      component: mainIndex
    }, { alone: true }))

    // 项目管理
    routes.push(createLayoutRoute('/projectManagement', routeName.projectManagement, generateProjectRoutes(true)))

    // 会员管理
    routes.push(createAloneRoute('/memberManagement', routeName.memberManagement, memberManagement))

    // 会员服务
    routes.push(createLayoutRoute('/memberServices', routeName.memberServices, MEMBER_SERVICE_ROUTES))

    // 专家管理
    routes.push(createAloneRoute('/expertManagement', routeName.expertManagement, expertManagement))

    // 个人中心（隐藏）
    routes.push(createAloneRoute('/personal', routeName.personal, personal, { hidden: true }))

    // 消息中心
    routes.push(createAloneRoute('/message', routeName.message, Message))

    // 下载中心
    routes.push(createAloneRoute('/download', routeName.download, DownLoadCenter))

    // 用户中心
    routes.push(createAloneRoute('/User', routeName.User, User))

    // 配置管理
    routes.push(createLayoutRoute('/configuration', routeName.configuration, CONFIG_ROUTES))

    // 评审管理
    routes.push(createLayoutRoute('/examine', routeName.examine, [
      { path: '/examine/list', name: routeName.examineList, component: ExamineList, iconCls: 'fa fa-dashboard' },
      { path: '/examine/define', name: routeName.examineDefine, component: ExamineDefine, iconCls: 'fa fa-dashboard' }
    ]))

    // 菜单管理
    routes.push(createAloneRoute('/menu', routeName.menu, Menu))

    // 操作日志
    routes.push(createAloneRoute('/log', routeName.log, log))

    // 导出模板
    routes.push(createAloneRoute('/Template', routeName.Template, Template))

    // 项目审核
    routes.push(createAloneRoute('/Auditing', routeName.log, Auditing)) // 注意：这里 name 使用了 routeName.log，建议改为 routeName.auditing

    // 角色管理
    routes.push(createAloneRoute('/role', routeName.role, Role))
  }
  
  // 普通用户 & 会员
  else if (userType == USER_TYPE.NORMAL || userType == USER_TYPE.MEMBER) {
    routes.push(createLayoutRoute('/index', routeName.home, {
      path: '/index',
      name: 'home',
      component: memberIndex
    }, { alone: true }))

    // 项目申报
    routes.push(createLayoutRoute('/projectManagement', routeName.projectApplication, generateProjectRoutes(false)))

    // 会员服务
    routes.push(createLayoutRoute('/memberServices', routeName.memberServices, MEMBER_SERVICE_ROUTES))

    // 会员申请
    routes.push(createAloneRoute('/memberManagement', routeName.memberApplication, memberApplication))

    // 缴费申报
    routes.push(createAloneRoute('/paymentDeclaration', routeName.paymentDeclaration, paymentDeclaration))

    // 下载中心
    routes.push(createAloneRoute('/download', routeName.download, DownLoadCenter))

    // 个人中心（隐藏）
    routes.push(createAloneRoute('/personal', routeName.personal, personal, { hidden: true }))
  }
  
  // 专家 & 专家额外角色
  else if (userType == USER_TYPE.EXPERT || userType == USER_TYPE.EXPERT_EXTRA) {
    routes.push(createLayoutRoute('/index', routeName.home, {
      path: '/index',
      name: 'home',
      component: expert
    }, { alone: true }))

    routes.push(createAloneRoute('/expertManagement', routeName.expertApplication, expertApplication))
    routes.push(createAloneRoute('/examineProject', routeName.examineProject, examineProject))
    routes.push(createAloneRoute('/download', routeName.download, DownLoadCenter))
    routes.push(createAloneRoute('/personal', routeName.personal, personal, { hidden: true }))
  }
  
  // 未知用户类型处理
  else {
    console.warn(`Unknown userType: ${userType}, redirecting to login`)
    return []
  }

  // 404 通配符路由
  routes.push({
    path: '*',
    redirect: '/404',
    hidden: true
  })

  return routes
}

// ==================== 路由实例创建 ====================

/**
 * 创建路由实例
 * 注意：实际项目中应在获取用户权限后调用此方法
 */
export const createRouter = () => {
  const userType = sessionStorage.getItem('userType')
  console.log('Current userType:', userType)

  return new Router({
    mode: 'history',
    routes: [
      ...defaultRouter,
      ...generateRoutesByRole(userType)
    ]
  })
}

// 默认导出（兼容原有代码）
const userType = sessionStorage.getItem('userType')
console.log('Current userType:', userType)

export default new Router({
  mode: 'history',
  routes: [
    ...defaultRouter,
    ...generateRoutesByRole(userType)
  ]
})

export {
  defaultRouter,
  // addRouter 改为 generateRoutesByRole 导出，保持兼容性
  generateRoutesByRole as addRouter
}


// WEBPACK FOOTER //
// ./src/system/index/router/index.js